import { useCallback, useEffect, useMemo, useState } from 'react'

import { Link, useLocation } from 'react-router-dom'

import { PiTextAlignJustifyThin } from 'react-icons/pi'

import bemit from '@/Functions/bemit'

const pages =
[
	{
		name: 'Vendre',
		path: '/vendre-estimer'
	},
	{
		name: 'Acheter',
		path: '/acheter'
	},
	{
		name: 'Créateurs de patrimoine',
		path: '/createurs-de-patrimoine'
	},
	{
		name: 'Osaba',
		path: '/qui-sommes-nous'
	},
	{
		name: 'Blog',
		path: '/blog'
	},
	{
		name: 'Contact',
		path: '/contact'
	}
];

/**
 *
 * @param { object } props
 *
 * @param { array<string> } props.bemit Modificateurs de classe principale
 *
 * @returns { React.ReactElement }
 */
export default function Navbar (props)
{
	const [open, setOpen] = useState(false);

	const toggleMenu = useCallback(function ()
	{
		setOpen(open => !open);
	},
	[]);

	const location = useLocation();

	useEffect(function ()
	{
		setOpen(false);
	},
	[location.pathname]);

	const modifiers = useMemo(function ()
	{
		const modifiers = (props.bemit || []).slice(0);

		if (open) modifiers.push('open');

		return modifiers;
	},
	[props.bemit, open]);

	const ITEMS = pages.map(function (item)
	{
		if (item.name === 'Contact')
		{
			return (
				<li key={ item.path } className="c-navbar__item is-contact">
					<Link to={ item.path } key={ item.path }
						className="c-navbar__link is-contact">
						{ item.name }
					</Link>
				</li>
			);
		}

		return (
			<li key={ item.path } className="c-navbar__item">
				<Link to={ item.path } key={ item.path }
					className="c-navbar__link">
					{ item.name }
				</Link>
			</li>
		);
	});

	return (
		<nav className={ bemit('c-navbar', modifiers) }>

			<button type="button" onClick={ toggleMenu }
				className="c-navbar__mobile-btn">
				<PiTextAlignJustifyThin />
			</button>

			<ul id="navmenu" className="c-navbar__list">
				{ ITEMS }
			</ul>

		</nav>
	);
}
